import { useState } from 'react'
import { useApiBlobFileSelfRegister } from '../../../api-new/state/storage'
import { useLoad } from '../../../shared/hooks/load'

export const SelfRegisterHeroImage = ({ identifier }) => {
  const apiBlobFileSelfRegister = useApiBlobFileSelfRegister()

  const [image, updateImage] = useState('')

  useLoad(
    async () => {
      if (identifier) {
        const file = await apiBlobFileSelfRegister.get(`${identifier}/identifier`)

        if (file) {
          const image = await getBase64(file)
          updateImage(image)
        }
      }
    },
    [identifier]
  )

  return (
    <div className="row">
      <div className="mx-auto col-12 col-lg-8">
        {image ? <img className="w-100" src={image} alt="logo" /> : <img className="w-100" src="/content_placeholder.png" alt="logo" />}
      </div>
    </div>
  )
}

const getBase64 = blob => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader()
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.readAsDataURL(blob)
  })
}
